<template>
  <div
    class="v-input v-input__select"
    :class="{
      'v-input--is-dirty': isDirty,
      'v-input--is-disabled': disabled,
      'v-input__select--is-open': selectToggleState,
      'v-input__error--border': !!errors.has(newName),
    }"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <label class="v-input__label" v-if="label">
      <template v-if="boldLabel && checkedBold">
        <strong>{{ label }}</strong>
      </template>
      <template v-else>
        {{ label }}
      </template>
    </label>
    <select
      v-if="!form || 0 === form.length"
      class="v-input__field fontawesome-select"
      v-model="model"
      type="text"
      :name="name"
      :disabled="disabled"
      :id="id || `${name}-select`"
      @change="$emit('input', model), toggleSelect, $emit('change', model)"
      @blur="setSelectFalse"
      @mouseup="toggleSelect"
    >
      <option
        v-if="zeroOption != '' && showZeroOption == 1"
        key="zero-option"
        :value="0"
      >
        {{ zeroOption }}
      </option>
      <option v-else key="zero-option" :value="``"></option>
      <template v-if="sort">
        <option
          v-for="(option, key) in sortProperties(options, sortBy, order)"
          :key="`${option[0]}-option`"
          :value="option[0]"
        >
          {{ option[1] }}
        </option>
      </template>
      <option
        v-for="(option, key) in options"
        :key="`${key}-option`"
        :value="key"
        v-else
      >
        {{ option }}
      </option>
    </select>
    <select
      v-else
      class="v-input__field fontawesome-select"
      v-model="model"
      type="text"
      :form="form"
      :name="name"
      :id="id || `${name}-select`"
      :disabled="disabled"
      @change="$emit('input', model), toggleSelect, $emit('change', model)"
      @blur="setSelectFalse"
      @mouseup="toggleSelect"
    >
      <option
        v-if="zeroOption != '' && showZeroOption == 1"
        key="zero-option"
        :value="0"
      >
        {{ zeroOption }}
      </option>
      <option v-else key="zero-option" :value="``"></option>
      <option
        v-for="(option, key) in options"
        :key="`${key}-option`"
        :value="key"
      >
        {{ option }}
      </option>
    </select>

    <span class="v-input__select__icon">
      <i class="fa fa-angle-down"></i>
    </span>

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";

export default {
  data() {
    return {
      selectToggleState: false,
    };
  },
  computed: {
    isDirty() {
      return this.model !== null;
    },
  },
  mixins: [field],
  props: {
    options: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    zeroOption: {
      default() {
        return "";
      },
      type: String,
    },
    showZeroOption: {
      default() {
        return "1";
      },
      type: String,
    },
    form: {
      default() {
        return "";
      },
      type: String,
    },
    id: {
      default: "",
      type: String,
    },
    sort: {
      default: false,
      type: Boolean,
    },
    sortBy: {
      default: "key",
      type: String,
    },
    order: {
      default: "asc",
      type: String,
    },
    customOrder: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    boldLabel: {
      default: false,
      type: Boolean,
    },
    checkedBold: {
      default: false,
      type: [Boolean, String, Number, Array],
    },
  },
  watch: {
    errors: function (value) {},
  },
  methods: {
    toggleSelect() {
      return this.selectToggleState
        ? this.setSelectFalse()
        : this.setSelectTrue();
    },
    setSelectTrue() {
      return (this.selectToggleState = true);
    },
    setSelectFalse() {
      return (this.selectToggleState = false);
    },
    sortProperties(obj, sortBy, order) {
      var sortable = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          sortable.push([key, obj[key]]);
        }
      }
      if (sortBy == "key") {
        sortable.sort(function (a, b) {
          var x = parseInt(a[0]),
            y = parseInt(b[0]);
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      } else if (sortBy == "custom") {
        sortable = this.customOrder;
      } else {
        sortable.sort(function (a, b) {
          var x = a[1].toLowerCase(),
            y = b[1].toLowerCase();
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      }
      return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VSelect.vue